// src/utils/FormatDate.js

/**
 * ISO tarih / timestamp değerini
 * Türkçe, okunur formatta döner.
 *
 * Örnek çıktı:
 * 21.12.2025 21:34
 */
export const formatDateTimeTR = (value) => {
  if (!value) return "";

  const d = new Date(value);

  if (isNaN(d.getTime())) return value; // bozuk tarih gelirse ham bas

  return d.toLocaleString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
